<div class="text-center {{ social }}">
    <nb-icon [icon]="social" pack="fab" class="fa-3x"></nb-icon>
  </div>